<template>
	<div class="d-flex flex-column justify-center log" >
		<div>
			<v-form ref="form" @submit.prevent="login" class="width mx-auto">
				<div class="d-flex flex-column justify-center align-center">
					<v-img 
						src="@/assets/logo.png"
						max-width="150px"
						max-height="200px"
						contain
						class="my-4"
					/>
				</div>
				
				<v-row>
					<v-col cols="12" class="">
						<v-text-field
							v-model="username"
							:label="$T('inputs.username')"
							outlined
							dense
							hide-details
							:rules="rules.required"
						/>
					</v-col>

					<v-col cols="12" class="">
						<v-text-field
							v-model="password"
							:label="$T('inputs.password')"
							:type="showPassword ? 'text' : 'password'"
							:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
							@click:append="showPassword = !showPassword"
							outlined
							dense
							hide-details
							:rules="rules.required"
						/>
					</v-col>

					<v-col class="text-center ">
						<v-btn
							color="primary white--text"
							width="100%"
							type="submit"
							:loading="loading"
							:disabled="loading"
						>
							{{ $T('Login.login') }}
						</v-btn>
					</v-col>
				</v-row>
			</v-form>
		</div>
		
		<div class="powered-by mt-5 px-2 pb-1">
			<p class="mb-0">Ugarit - v{{version}}</p>
			<p class="mb-0">
				powered by
				<a target="_blank" href="https://www.beetronix.com">Beetronix</a>
			</p>
		</div>
	</div>
</template>

<script>
import rules from '@/helpers/validation-rules'
import { VERSION } from '@/constants'
export default {
	data() {
		return {
			showPassword: false,
			username: null,
			password: null,
			rules,
			loading: false,
			version: VERSION 
		}
	},
	methods: {
		login() {
			if (this.$refs.form.validate()) {
				this.loading = true
				this.$store.dispatch('auth/login', {
					username: this.username,
					password: this.password
				}).then(() => {
					this.$router.replace({ name: 'home' });
				}).finally(() => {
					this.loading = false
				})
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.log {
	width: 100%;
	height: 90vh;
}
.width {
	width: 30%;
	@media only screen and (min-width: 600px) and (max-width: 960px){
		width: 50%;
	}
	@media only screen and (max-width: 600px) {
		width: 90%;
	}
}
.powered-by {
	position: absolute;
	bottom: 10px;
	left: 0;

	width: 100%;

	* {
		font-size: .82rem !important;
	}
}
</style>